export const columns = [
  {
    name: "Location",
    cell: (row) => (
      <div
        className='report-link'
        onClick={() => {
          row.handler(row?.location?.id,row?.location?.name);
          row.fetchLocation(row?.location?.id);
        }}
        style={{ cursor: "pointer" }}
      >
        {row["location"]["name"]}
      </div>
    ),
  },
  {
    name: "Target",
    cell: (row) => row["targetAccounts"],
  },
  {
    name: "Current accounts",
    cell: (row) => row["currentAccounts"],
  },
  {
    name: "New accounts",
    cell: (row) => row["newAccounts"],
  },
  {
    name: "New houses",
    cell: (row) => row["newHouses"],
  },
];

export const exportAccountsReportHeaders = [
  {
    label: "Location",
    key: "location",
  },
  {
    label: "Current accounts",
    key: "currentAccounts",
  },
  {
    label: "New Accounts",
    key: "newAccounts",
  },
  {
    label: "New houses",
    key: "newHouses",
  },
  {
    label: "Target amount",
    key: "targetAccounts",
  },
];